import Markdown from 'react-markdown'
import './Specific.css'

interface SpecificProps {
    characteristics?: Array<{ title: string; value?: string }>
}

export const Specific = ({ characteristics }: SpecificProps) => {
    return (
        <table className='specific'>
            <tbody>
                {characteristics?.map(
                    (item, index) =>
                        item.value && (
                            <tr key={index}>
                                <td className='specific-title w-[50%]'>
                                    <div>
                                        <span>{item.title}</span>
                                    </div>
                                </td>
                                <td className='specific-value'>
                                    <div>
                                        <Markdown>{item.value}</Markdown>
                                    </div>
                                </td>
                            </tr>
                        )
                )}
            </tbody>
        </table>
    )
}
